import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'


class DataTableBloc {

    rowtableListPPIChannel = new Subject();
    rowtableListPromotionChannel = new Subject();
    rowtableListGradePromotionChannel = new Subject();
    rowtableListPerjadinChannel = new Subject();
    rowtableListPresensiChannel = new Subject();

    repository = new DataTableRepository()

    constructor() {
        this.rowtableListPPIChannel.next({status: apiResponse.INITIAL})
        this.rowtableListPromotionChannel.next({status: apiResponse.INITIAL})
        this.rowtableListGradePromotionChannel.next({status: apiResponse.INITIAL})
        this.rowtableListPerjadinChannel.next({status: apiResponse.INITIAL})
        this.rowtableListPresensiChannel.next({status: apiResponse.INITIAL})
    }

    fetchRowTableListPPI = async (query, cancelToken) => {
        try {
            this.rowtableListPPIChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableListPPI(query, cancelToken).then((result) => {
                this.rowtableListPPIChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableListPPIChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

    fetchRowTableListPromotion = async (query, cancelToken) => {
        try {
            this.rowtableListPromotionChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableListPromotion(query, cancelToken).then((result) => {
                this.rowtableListPromotionChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableListPromotionChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }
    
    fetchRowTableListGradePromotion = async (query, cancelToken) => {
        try {
            this.rowtableListGradePromotionChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableListGradePromotion(query, cancelToken).then((result) => {
                this.rowtableListGradePromotionChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableListGradePromotionChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

    fetchRowTableListPerjadin = async (query, cancelToken) => {
        try {
            this.rowtableListPerjadinChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableListPerjadin(query, cancelToken).then((result) => {
                this.rowtableListPerjadinChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableListPerjadinChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

    fetchRowTableListPresensi = async (query, cancelToken) => {
        try {
            this.rowtableListPresensiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTableListPresensi(query, cancelToken).then((result) => {
                this.rowtableListPresensiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableListPresensiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log('rxjs', 'Channel Unsubscribed')}
    }

}
export default DataTableBloc